import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotspot-tracking',
  templateUrl: './hotspot-tracking.component.html',
  styleUrls: ['./hotspot-tracking.component.scss']
})
export class HotspotTrackingComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
